module.exports = __webpack_public_path__ + "static/media/wateringcan.93a3fc5d.png";